'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _deprecated = require('../utils/propTypes/deprecated');

var _deprecated2 = _interopRequireDefault(_deprecated);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Color = require('../core/Color');

var _Styles = require('../utils/Styles');

var _colors = require('HubStyleTokens/colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var USE_CLASSES = {
  default: '',
  island: 'is--island'
};

var overhangDeprecationWarning = {
  message: 'UISection: The `overhang` prop is deprecated. Use `UIScrollContainer` instead.',
  key: 'UISection: overhang'
};

var scrollShadowGradient = function scrollShadowGradient(direction) {
  if (direction === 'vertical') {
    return (0, _styledComponents.css)(['background-image:linear-gradient(to bottom,', ',', '),linear-gradient(to top,', ',', '),linear-gradient(to bottom,', ',', '),linear-gradient(to top,', ',', ');background-position:top,bottom,top,bottom;background-size:100% 4em,100% 4em,100% 1em,100% 1em;overflow-x:hidden;overflow-y:auto;'], _colors.OLAF, (0, _Color.rgba)(_colors.OLAF, 0), _colors.OLAF, (0, _Color.rgba)(_colors.OLAF, 0), _colors.KOALA, (0, _Color.rgba)(_colors.KOALA, 0), _colors.KOALA, (0, _Color.rgba)(_colors.KOALA, 0));
  }
  return (0, _styledComponents.css)(['background-image:linear-gradient(to right,', ',', '),linear-gradient(to left,', ',', '),linear-gradient(to right,', ',', '),linear-gradient(to left,', ',', ');background-position:0 0,100% 0,0 0,100% 0;background-size:4em 100%,4em 100%,1em 100%,1em 100%;overflow-x:auto;overflow-y:hidden;'], _colors.OLAF, (0, _Color.rgba)(_colors.OLAF, 0), _colors.OLAF, (0, _Color.rgba)(_colors.OLAF, 0), _colors.KOALA, (0, _Color.rgba)(_colors.KOALA, 0), _colors.KOALA, (0, _Color.rgba)(_colors.KOALA, 0));
};

var scrollShadowContainer = (0, _styledComponents.css)(['background-attachment:local,local,scroll,scroll;background-repeat:no-repeat;']);

var ScrollWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'UISection__ScrollWrapper'
})(['height:', ';', ';', ';& >:last-child{margin-bottom:0;}'], function (props) {
  return (0, _Styles.toPx)(props.height);
}, function (props) {
  return props.overhang ? scrollShadowContainer : null;
}, function (props) {
  return props.overhang ? scrollShadowGradient(props.overhangDirection) : null;
});

var hasPingedNewRelic = false;

var UISection = _react2.default.createClass({
  displayName: 'UISection',

  propTypes: {
    children: _react.PropTypes.node,
    height: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
    overhang: (0, _deprecated2.default)(_react.PropTypes.bool, overhangDeprecationWarning, false),
    overhangDirection: (0, _deprecated2.default)(_react.PropTypes.oneOf(['horizontal', 'vertical']), overhangDeprecationWarning, 'horizontal'),
    use: _react.PropTypes.oneOf(Object.keys(USE_CLASSES)).isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      overhang: false,
      overhangDirection: 'horizontal',
      use: 'default'
    };
  },
  getClassName: function getClassName() {
    var _props = this.props,
        className = _props.className,
        overhang = _props.overhang,
        overhangDirection = _props.overhangDirection,
        use = _props.use;

    return (0, _classNames2.default)('is--module', USE_CLASSES[use], className, 'namespaced-hack-section', {
      'private-scroll__wrapper--horizontal': overhang && overhangDirection === 'horizontal'
    });
  },
  render: function render() {
    var _props2 = this.props,
        children = _props2.children,
        overhang = _props2.overhang,
        overhangDirection = _props2.overhangDirection,
        use = _props2.use,
        role = _props2.role,
        rest = _objectWithoutProperties(_props2, ['children', 'overhang', 'overhangDirection', 'use', 'role']);

    if (overhang) {
      _devLogger2.default.warn(overhangDeprecationWarning);
      if (window.newrelic && !hasPingedNewRelic) {
        hasPingedNewRelic = true;
        window.newrelic.addPageAction('uisection-overhang');
      }
    }

    var computedRole = role === undefined && overhang ? 'region' : role;

    return _react2.default.createElement(
      ScrollWrapper,
      _extends({}, rest, {
        className: this.getClassName(),
        overhang: overhang,
        overhangDirection: overhangDirection,
        role: computedRole,
        tabIndex: overhang ? '0' : null,
        use: use
      }),
      children
    );
  }
});

exports.default = UISection;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/section/UISection.js
// module id = 208
// module chunks = 3 4 5